import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
// eslint-disable-next-line import/no-named-as-default
import ResourceContext from '@/components/Resources/context';
import CircleClose from '@/components/Icon/CircleClose';

const FilterConditionPC = () => {
  const { t } = useTranslation('resources');
  const { filterTags, deleteFilterTagAndUpdatePath, query, setQueryAndUpdatePath, resourceList } =
    useContext(ResourceContext);
  const { totalCount } = resourceList?.content || { totalCount: 0 };

  return (
    <div className="flex justify-between py-[32px] leading-normal text-[#484C70]	">
      <div className="flex items-center">
        <p
          className="w-[213px] leading-[24px] text-[#8D8FA6]"
          dangerouslySetInnerHTML={{ __html: t('资源条数', { total: totalCount }) }}
        />
        <div className="ml-[24px] flex">
          {filterTags?.map?.((tag) => (
            <div
              key={tag.value}
              className="mr-[12px] flex items-center rounded-[16px] bg-[#1B1F4D] p-[6px] pl-[12px] text-[14px] text-white"
            >
              <span className="mr-[12px] flex items-center">{tag.label}</span>
              <CircleClose onClick={() => deleteFilterTagAndUpdatePath(tag)} className="cursor-pointer align-middle" />
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center leading-[24px]">
        <span
          onClick={() =>
            setQueryAndUpdatePath({ order: query?.order === 'publish' ? undefined : 'publish', page: '1' })
          }
          className={classNames(query?.order === 'publish' && 'text-[#FF5353]', 'cursor-pointer hover:text-[#FF5353]')}
        >
          {t('最新发布')}
        </span>
        <div className="mx-[12px] h-[16px] w-[1px] bg-[#DFE0ED]" />
        <span
          onClick={() => setQueryAndUpdatePath({ order: query?.order === 'view' ? undefined : 'view', page: '1' })}
          className={classNames(query?.order === 'view' && 'text-[#FF5353]', 'cursor-pointer hover:text-[#FF5353]')}
        >
          {t('浏览最多')}
        </span>
      </div>
    </div>
  );
};

export default FilterConditionPC;
